import { Box, Button } from "@material-ui/core";
import { useGetPropagandaById } from "data/api/gestao/propaganda/get-propaganda-by-id";
import { usePutAtualizarPropaganda } from "data/api/gestao/propaganda/put-atualizar-propaganda";
import { PropagandaModel } from "model/api/gestao/propaganda/propaganda-model";
import { PropagandaFormFields } from "model/app/forms/propaganda/propaganda-form-fields";
import { useCallback, useEffect, useRef, useState } from "react";
import { useToastSaurus } from "services/app";
import { picker } from "utils/picker";
import { FormPropagandaCadastro } from "views/components/form/master/propaganda/propaganda-cadastro/form-propaganda-cadastro"
import { DefaultFormRefs } from "views/components/form/utils";
import { OkIcon } from "views/components/icons";
import { EnumTipoPessoas } from 'model/enums/enum-tipo-pessoas';
import { useSessaoAtual } from 'services/app';

interface PropagandaEdicaoContentProps {
    id: string;
    disabled: boolean;
    setRevendaIdPropaganda:(value:string) => void
}

export const PropagandaEdicaoContent = ({ id,  disabled , setRevendaIdPropaganda}: PropagandaEdicaoContentProps) => {

    const { getPropagandaById, carregando: carregandoGet } = useGetPropagandaById();

    const { putAtualizarPropaganda, carregando: carregandoPut } = usePutAtualizarPropaganda();

    const formRef = useRef<DefaultFormRefs<PropagandaFormFields>>(null)
    const { tipoUsuario, usuario } = useSessaoAtual();

    const carregando = carregandoGet || carregandoPut;

    const { showToast } = useToastSaurus();

    const [propagandaForm, setPropagandaForm] = useState<PropagandaFormFields>(new PropagandaFormFields());
    const propagandaModelRef = useRef<PropagandaModel>(new PropagandaModel())

    const handleSubmit = useCallback(async (modelF: PropagandaFormFields) => {
        try {

            const respostasDisponiveis = modelF.respostasDisponiveis.split(';').map(r => r.trim()).filter(r => r.length > 0);

            const propagandaToUpdate = picker<PropagandaModel>(
                modelF,
                propagandaModelRef.current,
            )

            propagandaToUpdate.respostasDisponiveis = respostasDisponiveis;


            const res = await putAtualizarPropaganda(propagandaToUpdate)

            if (!res) {
                return
            }

            if (res.erro) throw res.erro

            showToast('success', 'Propaganda atualizada.')

        } catch (e: any) {
            showToast('error', e.message)
        }
    }, [putAtualizarPropaganda, showToast])

    const getPropagandaWrapper = useCallback(async () => {
        try {

            const res = await getPropagandaById(id)

            if (res.erro) throw res.erro

            if (!res.resultado?.data) return
            propagandaModelRef.current = res.resultado.data
            
            setRevendaIdPropaganda(res.resultado.data.revendaId ?? '');


            const modelForm = picker<PropagandaFormFields>(
                res.resultado.data, new PropagandaFormFields());

            if (modelForm.respostasDisponiveis) {
                modelForm.respostasDisponiveis = modelForm.respostasDisponiveis
                    .split(',')
                    .join(';');
            }

            setPropagandaForm(modelForm)
        } catch (e: any) {
            showToast('error', e.message)
        }
    }, [getPropagandaById, id, setRevendaIdPropaganda, showToast])

    const recarregarForm = useCallback((modelForm: PropagandaFormFields) => {
        formRef.current?.fillForm(modelForm)
    }, [])


    useEffect(() => {
        getPropagandaWrapper()
    }, [getPropagandaWrapper])


    useEffect(() => {
        recarregarForm(propagandaForm)
    }, [propagandaForm, recarregarForm])

    const isSoftwareHouse = tipoUsuario() === EnumTipoPessoas.SoftwareHouse;

    const usuarioId =  tipoUsuario() === EnumTipoPessoas.Revendedor
            ? usuario?.Id
            : null;

    const isRevendaOwner = propagandaForm.revendaId === usuarioId;

    const canEdit = isSoftwareHouse || isRevendaOwner;

    return (
        <Box height='100%' display='flex' flexDirection='column'>
            <FormPropagandaCadastro
                onSubmit={handleSubmit}
                loading={carregando}
                showLoading={carregando}
                ref={formRef}
                disabled={!canEdit}
            />
            <Box p={2}>
                <Button size='large' fullWidth variant='contained' color='primary'
                    onClick={() => {
                        formRef.current?.submitForm();
                    }}>
                    <OkIcon tipo="BUTTON_PRIMARY"></OkIcon>  Salvar
                </Button>
            </Box>
        </Box>
    )
}